(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('FixationDialogController', FixationDialogController);

    FixationDialogController.$inject = ['$timeout', '$scope', '$stateParams', 'entity', 'Fixation', 'Lot',
        'selectedContract', 'LotCustomService', 'ToastrService'];

    function FixationDialogController ($timeout, $scope, $stateParams, entity, Fixation, Lot, 
            selectedContract, LotCustomService, ToastrService) {
        var vm = this;

        vm.fixation = entity;

        vm.fixation.contract = selectedContract;
        vm.fixation.fixDate = new Date();
        vm.fixation.priceUnit = selectedContract.fixedPriceUnitType; // set as default value
        vm.fixation.fixedPrice = selectedContract.fixedPrice;
        vm.fixation.unitType = selectedContract.qtyUnitType;
        vm.fixation.quantity = selectedContract.quantity;
        vm.fixation.priceType = selectedContract.onCallPriceType;
        vm.fixation.lots = [];

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.lots = [];
        loadLots();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        vm.datePickerOpenStatus.createdOn = false;
        vm.datePickerOpenStatus.modifiedOn = false;
        vm.datePickerOpenStatus.fixDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
        function loadLots() {
            var cid = vm.fixation.contract.id;
            var ctype = vm.fixation.contract.contractType;

            LotCustomService.lotsEligibleForFixation(cid, ctype).then(function(response) {
                vm.lots = response.data;
                vm.gridOptions.data = vm.lots;
            });
        }

        vm.gridOptions = {
            enableRowSelection: true,
            enableFiltering: true,
            onRegisterApi: function( gridApi ) {
                $scope.gridApi = gridApi;
            },
            columnDefs: [
                //new ui grid cofigurations
                { name: 'ID', field: 'id', width: 100, visible: true}, 
                { name: 'Lot', field: 'lotRef', width: 100, visible: true },
                { name: 'Status', field: 'lotStatus', width: 110, visible: true },
                { name: 'Seller', field: 'seller', width: 150, visible: true },
                { name: 'Qty', field: 'qtyBales', width: 90, visible: true },
                { name: 'Growth', field: 'growth', width: 200, visible: true },
                { name: 'CY', field: 'cropYear', width: 90, visible: true },
                { name: 'Type', field: 'lotType', width: 90, visible: true }
            ]
        };
    }
})();
